import * as React from 'react';

function USDCMark(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 350 350"
    >
      <path
        d="M175 350c96.98 0 175-78.02 175-175S271.98 0 175 0 0 78.02 0 175s78.02 175 175 175zm0 0"
        fill="#2775ca"
      />
      <path
        d="M223.125 202.707c0-25.52-15.313-34.27-45.938-37.914-21.875-2.918-26.25-8.75-26.25-18.961 0-10.207 7.293-16.77 21.875-16.77 13.125 0 20.418 4.375 24.063 15.313.73 2.188 2.918 3.645 5.105 3.645h11.665c2.917 0 5.105-2.188 5.105-5.102v-.73c-2.918-16.043-16.043-28.438-32.813-29.895v-17.5c0-2.918-2.187-5.106-5.832-5.836h-10.937c-2.918 0-5.106 2.188-5.836 5.836v16.77c-21.875 2.917-35.727 17.5-35.727 35.73 0 24.062 14.582 33.539 45.207 37.187 20.418 3.645 26.981 8.02 26.981 19.688s-10.211 19.687-24.063 19.687c-18.96 0-25.523-8.023-27.71-18.96-.727-2.915-2.915-4.375-5.102-4.375H130.52c-2.915 0-5.102 2.187-5.102 5.105v.73c2.914 18.227 14.582 31.352 38.644 35v17.5c0 2.915 2.188 5.102 5.833 5.832h10.937c2.918 0 5.106-2.187 5.836-5.832v-17.5c21.875-3.648 36.457-18.96 36.457-38.648zm0 0"
        fill="#fff"
      />
      <path
        d="M137.813 279.27c-56.875-20.415-86.043-83.852-64.895-140 10.937-30.625 35-53.958 64.894-64.895 2.918-1.457 4.375-3.645 4.375-7.293V56.875c0-2.918-1.457-5.105-4.375-5.832-.73 0-2.187 0-2.917.727-69.27 21.875-107.188 95.523-85.313 164.792 13.125 40.833 44.48 72.188 85.313 85.313 2.917 1.457 5.835 0 6.562-2.918.73-.727.73-1.457.73-2.914v-10.211c0-2.187-2.187-5.102-4.375-6.562zm77.292-227.5c-2.917-1.458-5.835 0-6.562 2.917-.73.731-.73 1.458-.73 2.918v10.208c0 2.917 2.187 5.832 4.375 7.292 56.875 20.415 86.042 83.852 64.894 140-10.937 30.625-35 53.958-64.894 64.895-2.918 1.457-4.375 3.645-4.375 7.293V297.5c0 2.918 1.457 5.105 4.375 5.832.73 0 2.187 0 2.917-.727 69.27-21.875 107.188-95.523 85.313-164.793-13.125-41.562-45.211-72.917-85.313-86.042zm0 0"
        fill="#fff"
      />
    </svg>
  );
}

export default USDCMark;